module.exports = __webpack_public_path__ + "img/p1.c1e2f701.jpg";